/**
 * Posição do ativo no mapa (clicar ou arrastar o ponto) — Nexora Grid (frontend, US-406).
 *
 * Criado em: 16/10/2026 · Última modificação: 16/10/2026 · Versão: 1.0.0
 *
 * MapLibre com a base do OpenStreetMap (P1: mapas gratuitos). Em produção, tiles servidos pela plataforma.
 */
import * as maplibregl from "maplibre-gl";
import "maplibre-gl/dist/maplibre-gl.css";
import { useEffect, useRef } from "react";

const ESTILO: maplibregl.StyleSpecification = {
  version: 8,
  sources: { osm: { type: "raster", tiles: ["https://tile.openstreetmap.org/{z}/{x}/{y}.png"], tileSize: 256,
    attribution: "© OpenStreetMap" } },
  layers: [{ id: "osm", type: "raster", source: "osm" }],
};

export function MapaPosicao({ latitude, longitude, editavel, aoMudar }: {
  latitude: number; longitude: number; editavel: boolean; aoMudar: (lat: number, lon: number) => void;
}) {
  const caixa = useRef<HTMLDivElement>(null);
  const mapa = useRef<maplibregl.Map | null>(null);
  const marcador = useRef<maplibregl.Marker | null>(null);
  const callback = useRef(aoMudar);
  callback.current = aoMudar;

  useEffect(() => {
    if (!caixa.current) return;
    const m = new maplibregl.Map({ container: caixa.current, style: ESTILO, center: [longitude, latitude], zoom: 17,
      attributionControl: { compact: true } });
    m.addControl(new maplibregl.NavigationControl({ showCompass: false }), "top-right");
    const ponto = new maplibregl.Marker({ color: "#22d3ee", draggable: editavel }).setLngLat([longitude, latitude]).addTo(m);
    ponto.on("dragend", () => { const p = ponto.getLngLat(); callback.current(p.lat, p.lng); });
    if (editavel) m.on("click", (e: maplibregl.MapMouseEvent) => { ponto.setLngLat(e.lngLat); callback.current(e.lngLat.lat, e.lngLat.lng); });
    mapa.current = m;
    marcador.current = ponto;
    return () => m.remove();
  }, [editavel]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const atual = marcador.current?.getLngLat();
    if (atual && (Math.abs(atual.lat - latitude) > 1e-7 || Math.abs(atual.lng - longitude) > 1e-7)) {
      marcador.current?.setLngLat([longitude, latitude]);
      mapa.current?.easeTo({ center: [longitude, latitude] });
    }
  }, [latitude, longitude]);

  return <div ref={caixa} className="mapa-posicao" role="application"
    aria-label={editavel ? "Mapa: clique ou arraste o ponto para mudar a posição" : "Mapa da posição"} />;
}
